
export default {
  props: ['queryString'],
  data () {
    return {
      loading: false,
      query: this.getQueryString()
    }
  },
  methods: {
    search () {
      this.loading = true
      this.$router.push(`/s/${this.query}`)
    },
    getQueryString () {
      if (this.queryString === 'diagramWhat' || this.queryString === 'diagramWhere' || this.queryString === 'diagramHow') {
        return ''
      } else {
        return this.queryString || ''
      }
    }
  }
}
